import { View } from 'react-native';

import { EmptyState } from '@/components/ui/EmptyState';

export interface TemplateEmptyStateProps {
  /** Open the new-template flow (paywall or the New checklist sheet). */
  onNewTemplate: () => void;
}

/** Dashed-card "No templates yet" state — shared by Home and the Templates list. */
export function TemplateEmptyState({ onNewTemplate }: TemplateEmptyStateProps) {
  return (
    <View className="rounded-2xl border border-dashed border-border-strong bg-card">
      <EmptyState
        title="No templates yet"
        body="Create a reusable template to start your own runs."
        action={{
          variant: 'ink',
          size: 'md',
          icon: '+',
          label: 'New template',
          onPress: onNewTemplate,
        }}
      />
    </View>
  );
}
